module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SM1nAg/tc-custom/9783968651293.jpg?1705026482207",
      "alt": "This image is the cover for the book D-99: A Science Fiction Novel, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("D-99: A Science Fiction Novel, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Five citizens of Terra were being held on other worlds -- and the ultra-secret Department 99 existed only to set them, and others like them, free. Chapters alternate between stories of five Terrans being held by the authorities on alien planets and the efforts of a secret Terran government department to come up with plans to free them. In the midst of the planning and problems, a huge power outage causes even more trouble for D-99 as they struggle to keep the trouble from a problematic agent whose previous sufferings cause him to have severe claustrophobia and to react violently from it.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. B. Fyfe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("(1918-1997) US author whose first sf story, \"Locked Out\", appeared in Astounding in February 1940, but who became fully active, mainly with further stories in Astounding though with appearances in most other SF Magazines, only after army service in World War Two. By 1967, when he became inactive, he had published nearly 60 stories.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0